import { image, Image } from 'mostra';

const {
  genOriginalImageUrl,
  genOriginalImageUrlByImage,
  genImageUrl,
  genImageUrls,
  genImageUrlByImage,
  genImageUrlsByImage,
  createImage,
  uploadImage,
  sizes,
} = image;

const baseUrl = (): string => {
  const u = process.env.IMAGE_URL || process.env.VUE_APP_IMAGE_PREFIX_URL;
  return u || '';
};

const uploadImageEx = async (
  owner: string,
  file: File | Blob | Uint8Array,
  fileName: string,
  callback?: (snapshot: any) => void,
): Promise<Image> => uploadImage(
  owner,
  file,
  fileName,
  callback,
);

const genDownloadOriginalImageUrlEx = async (
  owner: string,
  id: string,
): Promise<string> => {
  const ret = await genOriginalImageUrl(owner, id);
  return ret;
};

const genDownloadOriginalImageUrlByImageEx = async (
  owner: string,
  img: Image | null,
): Promise<string> => {
  const ret = await genOriginalImageUrlByImage(owner, img);
  return ret;
};

// const genDownloadOriginalImageUrl = async (
//   owner: string | null,
//   id: string | null,
// ): Promise<string> => {
//   const ret = await genOriginalImageUrl(owner, id);
//   return ret;
// };
//
// const genDownloadOriginalImageUrlByImage = async (
//   owner: string | null,
//   img: Image | null,
// ): Promise<string> => {
//   const ret = await genOriginalImageUrlByImage(owner, img);
//   return ret;
// };

const genDownloadImageUrl = async (
  size: any,
  id: string | null | undefined,
): Promise<string | null> => {
  const ret = await genImageUrl(baseUrl(), size, id);
  return ret;
};

const genDownloadImageUrlByImage = async (
  size: any,
  img: Image | null,
): Promise<string | null> => {
  const ret = await genImageUrlByImage(baseUrl(), size, img);
  return ret;
};

const genDownloadImageUrls = async (
  size: any,
  ids: (string | null)[],
): Promise<string[]> => {
  const ret = await genImageUrls(baseUrl(), size, ids);
  return ret;
};

const genDownloadImageUrlsByImage = async (
  size: any,
  images: Image[],
): Promise<string[]> => {
  const ret = await genImageUrlsByImage(baseUrl(), size, images);
  return ret;
};

export {
  Image,
  genDownloadOriginalImageUrlEx,
  genDownloadOriginalImageUrlByImageEx,
  // genDownloadOriginalImageUrl,
  // genDownloadOriginalImageUrlByImage,
  genDownloadImageUrl,
  genDownloadImageUrls,
  genDownloadImageUrlByImage,
  genDownloadImageUrlsByImage,
  uploadImageEx,
  createImage,
  sizes,
};
